/**
 * VoiceSettingsPage - Voice and speech settings
 */

import VoiceSettingsPanel from '@components/voice/VoiceSettingsPanel';

export default function VoiceSettingsPage() {
  return (
    <div className="p-6">
      <VoiceSettingsPanel />
    </div>
  );
}
